import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaTelegram,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import logo from "../assets/images/logo.svg";

import pin from "../assets/images/pin.svg";
import telephonecall from "../assets/images/telephone-call.svg";
import { useNavigate } from "react-router-dom";
import "./Footer.css";
import showToast from "../components/Toast/Toaster";

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const handleOrderHistoryClick = () => {
    const userId = localStorage.getItem("UserId");

    if (!userId) {
      showToast.warning("Please login to view your order history.");
    } else {
      navigate("/orderhistory");
    }
  };
  const handleProfileClick = () => {
    const userId = localStorage.getItem("UserId");

    if (!userId) {
      showToast.warning("Please login to view your profile.");
    } else {
      navigate("/profile");
    }
  };
  const handleDashboardClick = () => {
    const userId = localStorage.getItem("UserId");

    if (!userId) {
      showToast.warning("Please login to view your dashboard.");
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <div className="f-border">
      <div className="container">
        <footer className="footer">
          <div className="footer-container">
            {/* Logo & Description  */}
            <div className="footer-logo">
              <div>
                <img src={logo} alt="JPS Jewels" />
              </div>
              <div className="footer-description">
                Unleash the radiance of your inner beauty with our premium
                jewelry brand - a perfect blend of sophistication and style.
              </div>

              <div className="social-icons">
                <p>
                  <a
                    href="https://www.facebook.com/share/1CQvZhtxgf/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                    style={{
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FaFacebookF />
                  </a>
                </p>
                <p>
                  <a
                    href="https://www.instagram.com/_jps_jewels_?igsh=aDRqdm5icmFvcmk2"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                    style={{
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FaInstagram />
                  </a>
                </p>
                {/* <p>
                  <FaTelegram />
                </p> */}
                <p>
                  <a
                    href="https://x.com/JPS_Jewels?t=er1KlTT0TPg3BDRnQL8d-w&s=09"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Twitter"
                    style={{
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {/* X (Twitter) SVG icon */}
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 1200 1227"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1199.97 0H950.684L599.985 494.13L249.316 0H0L491.684 704.13L0 1227H249.316L599.985 782.87L950.684 1227H1200L708.316 522.87L1199.97 0ZM899.97 1117.39L599.985 729.565L300.03 1117.39H134.684L599.985 563.565L1065.32 1117.39H899.97ZM1065.32 109.565L599.985 663.565L134.684 109.565H300.03L599.985 497.391L899.97 109.565H1065.32Z"
                        fill="#fff"
                      />
                    </svg>
                  </a>
                </p>
                <p>
                  <a
                    href="https://youtube.com/@jpsjewels-s8j?si=eFTVvj7cML-Bj_J_"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Youtube"
                    style={{
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FaYoutube />
                  </a>
                </p>
              </div>
            </div>
            {/* {/ Account Section /} */}
            <div className="footer-section">
              <h3>ACCOUNT</h3>
              <p onClick={handleDashboardClick} style={{ cursor: "pointer" }}>
                Dashboard
              </p>
              <p
                onClick={handleOrderHistoryClick}
                style={{ cursor: "pointer" }}
              >
                Order history
              </p>
              {/* <p>Wishlist</p> */}
              <p onClick={handleProfileClick} style={{ cursor: "pointer" }}>
                Profile
              </p>
            </div>

            {/* {/ Diamonds Section /} */}
            <div className="footer-section">
              <h3>DIAMONDS</h3>
              <p
                onClick={() => navigate("/diamond?q=filter")}
                style={{ cursor: "pointer" }}
              >
                Shop by Diamond
              </p>
              <p
                onClick={() => navigate("/jewellery?allTypes=1")}
                style={{ cursor: "pointer" }}
              >
                Shop by Jewellery
              </p>
            </div>

            {/* {/ Help Section /} */}
            <div className="footer-section">
              <h3>HELP</h3>
              <p onClick={() => navigate("/faq")} style={{ cursor: "pointer" }}>
                FAQ
              </p>
              <p
                onClick={() => navigate("/aboutus")}
                style={{ cursor: "pointer" }}
              >
                About us
              </p>
              <p
                onClick={() => navigate("/contactus")}
                style={{ cursor: "pointer" }}
              >
                Contact us
              </p>
            </div>

            {/* {/ Policies Section /} */}
            <div className="footer-section">
              <h3>POLICIES</h3>
              <p
                onClick={() => navigate("/privacypolicy")}
                style={{ cursor: "pointer" }}
              >
                Privacy Policy
              </p>
              <p
                onClick={() => navigate("/termsofuse")}
                style={{ cursor: "pointer" }}
              >
                Terms &amp; Conditions
              </p>
              <p
                onClick={() => navigate("/refundpolicy")}
                style={{ cursor: "pointer" }}
              >
                Refund &amp; Cancellation Policy
              </p>
              <p
                onClick={() => navigate("/shippingpolicy")}
                style={{ cursor: "pointer" }}
              >
                Shipping &amp; Delivery Policy
              </p>
              <p
                onClick={() => navigate("/contactus")}
                style={{ cursor: "pointer" }}
              >
                Contact Us
              </p>
            </div>

            {/* {/ Contact Section /} */}
            <div className="footer-section">
              <h3>CONTACT US</h3>
              <div className="phoneno">
                <img src={telephonecall} alt="pin" width="27px" />
                <div>
                  {/* <span>Call us 8 AM - 11 PM</span> */}
                  <span className="mb-2">
                    <a href="tel:+1 315 595 5055" className="note1">
                      +1 315 595 5055
                    </a>
                  </span>
                </div>
              </div>
              <div className="phoneno">
                {/* Fax Icon */}
                {/* <div style={{ width: "27px" }}> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="27"
                  height="27"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#c9a236"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="fax-icon"
                >
                  <path d="M16 2H8a2 2 0 0 0-2 2v4h12V4a2 2 0 0 0-2-2z" />
                  <path d="M16 6h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
                  <rect x="2" y="6" width="16" height="14" rx="2" />
                  <path d="M8 10h.01" />
                  <path d="M8 14h.01" />
                  <path d="M12 14h.01" />
                </svg>
                {/* </div> */}
                <div>
                  <span className="mb-2">
                    <a href="fax:+1 332 266 3843" className="note1">
                      +1 332 266 3843
                    </a>
                  </span>
                </div>
              </div>
              <div className="addresssec">
                <img src={pin} alt="pin" width="27px" fill="#c9a236" />
                <span className="note1">
                  A/1-1303, 13th Floor, Heaven Enclave, <br />
                  Hazira Sayan Road, Chhaprabhatha, <br />
                  Surat, Gujarat 394107, India
                </span>
              </div>
              <div className="addresssec">
                <img src={pin} alt="pin" width="27px" fill="#c9a236" />
                <span>
                  <a
                    href="https://maps.app.goo.gl/VEM2QQwyMtAYaVs49"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="note1"
                  >
                    108 W 39th Street, <br />
                    Ste 1006 #2133, <br />
                    New York, NY 10018, <br />
                    United States
                  </a>
                </span>
              </div>
            </div>
          </div>

          {/* {/ Footer Bottom /} */}
          <div className="fm">
            <div className="footermain">
              <div className="footer-bottom">
                Copyright © {currentYear} JPS Jewels. All Rights Reserved
              </div>
              <div className="footer-madeby">
                Made by{" "}
                <a
                  href="https://sparrowsofttech.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Sparrow Softtech
                </a>
              </div>
              <div className="pri-pol">
                <div
                  className="footer-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/termsofuse")}
                >
                  Terms &amp; Conditions
                </div>
                <div
                  className="footer-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/privacypolicy")}
                >
                  Privacy Policy
                </div>
                <div
                  className="footer-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/refundpolicy")}
                >
                  Refund &amp; Cancellation
                </div>
                <div
                  className="footer-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/shippingpolicy")}
                >
                  Shipping &amp; Delivery
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Footer;
